export const DATE_FORMAT = 'MM/DD/YYYY';
export const LIVE_STREAM = 'live-stream';
export const MAX_MESSAGE_BODY_LENGTH = 400;
export const MAX_MESSAGES_BUFFER = 1000;
export const TIMESTAMP_FORMAT = 'HH:mm';
export const WMST_USERS_TAG = '__WMST__';

export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIMESTAMP_FORMAT}`;
export const DEFAULT_CHANNEL = LIVE_STREAM;
